import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = "Conditions Générales d'Utilisation" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Dernière mise à jour : 05 avril 2025</p>

            <p>Veuillez lire attentivement ces conditions générales d'utilisation avant d'utiliser Notre Service.</p>

            <h1>Interprétation et Définitions</h1>
            <h2>Interprétation</h2>
            <p>
              Les mots dont la première lettre est en majuscule ont des significations définies sous les conditions suivantes.
            </p>
            <p>
              Les définitions suivantes auront la même signification qu'elles apparaissent au singulier ou au pluriel.
            </p>

            <h2>Définitions</h2>
            <p>Aux fins de ces Conditions Générales d'Utilisation :</p>
            <ul>
              <li>
                <strong>Affilié</strong> désigne une entité qui contrôle, est contrôlée par ou est sous contrôle commun
                avec une partie, où "contrôle" signifie la propriété de 50% ou plus des actions, des intérêts ou autres
                titres donnant droit de vote pour l'élection des administrateurs ou d'autres autorités de gestion.
              </li>
              <li>
                <strong>Société</strong> (désignée comme "la Société", "Nous", "Nos" ou "Notre" dans cet Accord)
                fait référence à Tanga Group Inc., Abidjan.
              </li>
              <li>
                <strong>Pays</strong> fait référence à : Côte d'Ivoire
              </li>
              <li>
                <strong>Service</strong> fait référence au Site Web.
              </li>
              <li>
                <strong>Conditions Générales d'Utilisation</strong> (également désignées comme "Conditions") désignent
                ces Conditions Générales d'Utilisation qui constituent l'accord complet entre Vous et la Société
                concernant l'utilisation du Service.
              </li>
              <li>
                <strong>Service de Médias Sociaux Tiers</strong> désigne tout service ou contenu (y compris les données,
                informations, produits ou services) fourni par un tiers qui peut être affiché, inclus ou mis à
                disposition par le Service.
              </li>
              <li>
                <strong>Site Web</strong> fait référence à Tanga, accessible depuis https://tangagroup.africa
              </li>
              <li>
                <strong>Vous</strong> désigne l'individu accédant ou utilisant le Service, ou la société, ou autre entité
                juridique au nom de laquelle cet individu accède ou utilise le Service, selon le cas.
              </li>
            </ul>

            <h1>Reconnaissance</h1>
            <p>
              Ce sont les Conditions Générales d'Utilisation qui régissent l'utilisation de ce Service et l'accord qui
              opère entre Vous et la Société. Ces Conditions Générales d'Utilisation définissent les droits et obligations
              de tous les utilisateurs concernant l'utilisation du Service.
            </p>
            <p>
              Votre accès et votre utilisation du Service sont conditionnés par Votre acceptation et votre conformité
              avec ces Conditions Générales d'Utilisation. Ces Conditions Générales d'Utilisation s'appliquent à tous
              les visiteurs, utilisateurs et autres qui accèdent ou utilisent le Service.
            </p>
            <p>
              En accédant ou en utilisant le Service, Vous acceptez d'être lié par ces Conditions Générales d'Utilisation.
              Si Vous n'êtes pas d'accord avec une partie de ces Conditions Générales d'Utilisation, Vous ne pouvez pas
              accéder au Service.
            </p>
            <p>
              Vous déclarez que vous avez plus de 18 ans. La Société ne permet pas aux personnes de moins de 18 ans
              d'utiliser le Service.
            </p>
            <p>
              Votre accès et votre utilisation du Service sont également conditionnés par Votre acceptation et votre
              conformité avec la Politique de Confidentialité de la Société. Notre Politique de Confidentialité décrit
              Nos politiques et procédures concernant la collecte, l'utilisation et la divulgation de Vos informations
              personnelles lorsque Vous utilisez l'Application ou le Site Web et Vous informe de Vos droits à la vie
              privée et de la manière dont la loi Vous protège. Veuillez lire attentivement Notre Politique de
              Confidentialité avant d'utiliser Notre Service.
            </p>

            <h1>Liens vers d'Autres Sites Web</h1>
            <p>
              Notre Service peut contenir des liens vers des sites web ou services tiers qui ne sont pas détenus ou
              contrôlés par la Société.
            </p>
            <p>
              La Société n'a aucun contrôle sur, et n'assume aucune responsabilité pour, le contenu, les politiques de
              confidentialité ou les pratiques des sites web ou services tiers. Vous reconnaissez et acceptez en outre
              que la Société ne sera pas responsable ou redevable, directement ou indirectement, de tout dommage ou
              perte causé ou présumé être causé par ou en connexion avec l'utilisation ou la dépendance à tout contenu,
              biens ou services disponibles sur ou via ces sites web ou services.
            </p>
            <p>
              Nous Vous conseillons fortement de lire les conditions générales et les politiques de confidentialité de
              tout site web ou service tiers que Vous visitez.
            </p>

            <h1>Résiliation</h1>
            <p>
              Nous pouvons résilier ou suspendre Votre accès immédiatement, sans préavis ni responsabilité, pour
              quelque raison que ce soit, y compris, sans limitation, si Vous violez ces Conditions Générales d'Utilisation.
            </p>
            <p>Lors de la résiliation, Votre droit d'utiliser le Service cessera immédiatement.</p>

            <h1>Limitation de Responsabilité</h1>
            <p>
              Nonobstant tout dommage que Vous pourriez encourir, la responsabilité totale de la Société et de ses
              fournisseurs en vertu de toute disposition de ces Conditions et Votre recours exclusif pour tout ce qui
              précède sera limité au montant effectivement payé par Vous via le Service ou 50 000 FCFA si Vous n'avez
              rien acheté via le Service.
            </p>
            <p>
              Dans la mesure maximale permise par la loi applicable, en aucun cas la Société ou ses fournisseurs ne
              seront responsables de dommages spéciaux, accessoires, indirects ou consécutifs (y compris, mais sans
              s'y limiter, les dommages pour perte de profits, perte de données ou autres informations, pour interruption
              d'activité, pour blessure personnelle, perte de vie privée découlant de ou liée de quelque manière que ce
              soit à l'utilisation ou à l'impossibilité d'utiliser le Service, les logiciels tiers et/ou le matériel
              tiers utilisé avec le Service, ou autrement en connexion avec toute disposition de ces Conditions), même
              si la Société ou tout fournisseur a été conseillé de la possibilité de tels dommages et même si le
              recours échoue à son objectif essentiel.
            </p>

            <h1>Clause "TEL QUEL" et "TEL QUE DISPONIBLE"</h1>
            <p>
              Le Service Vous est fourni "TEL QUEL" et "TEL QUE DISPONIBLE" et avec tous les défauts et vices sans
              garantie d'aucune sorte. Dans la mesure maximale permise par la loi applicable, la Société, en son nom
              propre et au nom de ses Affiliés et de leurs concédants et fournisseurs de services respectifs, décline
              expressément toutes les garanties, qu'elles soient expresses, implicites, statutaires ou autres, concernant
              le Service, y compris toutes les garanties implicites de qualité marchande, d'adéquation à un usage
              particulier, de titre et de non-contrefaçon, et les garanties qui peuvent découler du cours des relations
              commerciales, du cours de l'exécution, de l'usage ou de la pratique commerciale.
            </p>

            <h1>Loi Applicable</h1>
            <p>
              Les lois de la Côte d'Ivoire, à l'exclusion de ses règles de conflit de lois, régiront ces Conditions et
              Votre utilisation du Service. Votre utilisation de l'Application peut également être soumise à d'autres
              lois locales, nationales ou internationales.
            </p>

            <h1>Résolution des Litiges</h1>
            <p>
              Si Vous avez une préoccupation ou un litige concernant le Service, Vous acceptez de tenter d'abord de
              résoudre le litige de manière informelle en contactant la Société.
            </p>

            <h1>Pour les Utilisateurs de l'Union Européenne (UE)</h1>
            <p>
              Si Vous êtes un consommateur de l'Union Européenne, vous bénéficierez de toute disposition obligatoire
              de la loi du pays dans lequel vous résidez.
            </p>

            <h1>Conformité Légale</h1>
            <p>
              Vous déclarez et garantissez que (i) Vous n'êtes pas situé dans un pays soumis à l'embargo du gouvernement
              des États-Unis, ou qui a été désigné par le gouvernement des États-Unis comme un pays "soutenant le
              terrorisme", et (ii) Vous n'êtes pas inscrit sur une liste du gouvernement des États-Unis des parties
              interdites ou restreintes.
            </p>

            <h1>Divisibilité et Renonciation</h1>
            <h2>Divisibilité</h2>
            <p>
              Si une disposition de ces Conditions est jugée inapplicable ou invalide, cette disposition sera modifiée
              et interprétée pour accomplir les objectifs de cette disposition dans la plus grande mesure possible sous
              la loi applicable et les dispositions restantes continueront à être en pleine vigueur et effet.
            </p>

            <h2>Renonciation</h2>
            <p>
              Sauf disposition contraire, le fait de ne pas exercer un droit ou d'exiger l'exécution d'une obligation
              en vertu de ces Conditions n'affectera pas la capacité d'une partie à exercer ce droit ou à exiger cette
              exécution à tout moment ultérieur, ni le renoncement à une violation ne constituera un renoncement à toute
              violation ultérieure.
            </p>

            <h1>Interprétation de la Traduction</h1>
            <p>
              Ces Conditions Générales d'Utilisation peuvent avoir été traduites si Nous les avons mises à Votre
              disposition sur Notre Service.
            </p>
            <p>Vous acceptez que le texte original en français prévaudra en cas de litige.</p>

            <h1>Modifications de Ces Conditions Générales d'Utilisation</h1>
            <p>
              Nous nous réservons le droit, à Notre seule discrétion, de modifier ou de remplacer ces Conditions à tout
              moment. Si une révision est importante, Nous ferons des efforts raisonnables pour fournir un préavis d'au
              moins 30 jours avant que les nouvelles conditions ne prennent effet. Ce qui constitue un changement
              important sera déterminé à Notre seule discrétion.
            </p>
            <p>
              En continuant à accéder ou à utiliser Notre Service après que ces révisions deviennent effectives, Vous
              acceptez d'être lié par les conditions révisées. Si Vous n'acceptez pas les nouvelles conditions, en
              tout ou en partie, veuillez cesser d'utiliser le site web et le Service.
            </p>

            <h1>Contactez-Nous</h1>
            <p>Si vous avez des questions sur ces Conditions Générales d'Utilisation, Vous pouvez nous contacter :</p>

            <ul>
              <li>Par email : hello@tangagroup.africa</li>
              <li>Par téléphone : +225 27 22 49 49 49</li>
            </ul>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
